import { FooterWidgetWrapper } from "components/Footer";
import { SocialSharing } from "components/SocialSharing";
import { Heading5 } from "shared/components";

import styles from "./Footer005.module.scss";

export const Footer005 = ({ payload }) => {
  const title = payload?.title ?? "";
  const template = payload?.template ?? "light";

  return (
    <FooterWidgetWrapper className={styles[template]}>
      <div className={styles.block}>
        <Heading5 className={styles.title} color="dark">
          {title}
        </Heading5>
        <SocialSharing
          inline
          appearance="brand"
          buttonClassName={styles.button}
        />
      </div>
    </FooterWidgetWrapper>
  );
};

export default Footer005;
